import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { getAddresses } from '../../../api/ans';
import cancelicon from '../../../assets/images/cancelIcon.svg';
import { openSelectAddres, setSelectAddres } from '../../../store/slices/ordersSlice';
import { closePopup, openPopup } from '../../../store/slices/popupSlice';
import { useAppSelector } from '../../../store/store';
import AdressCard from '../../AdressCard/AdressCard';
import GreyButton from '../../ui/buttons/greyButton/GreyButton';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function SelectAddresPopup() {
  const [addreslist, setAddreslist] = useState([]);
  const [selectAddres, setSelectedAddres] = useState({ ref: 0 });
  const dispatch = useDispatch();
  const methods = useForm({});
  const selectAddresFromProps = useAppSelector(
    (state) => state.popup.popupProps.selectAddres
  );
  console.log(selectAddresFromProps);
  console.log(setAddreslist);

  const { handleSubmit } = methods;

  const onSubmit = (data) => {
    console.log(data);
  };

  useEffect(() => {
    getAddresses().then((data) => {
      console.log(data);
      setAddreslist(data);
      setSelectedAddres(data.find((item) => item?.ref === selectAddresFromProps?.ref));
      console.log(selectAddresFromProps);
    });
    dispatch(openSelectAddres(false));
  }, []);

  return (
    <div className={styles.addAdressWrapper}>
      <div className={styles.AddClc}>
        <h1 className={styles.headerAddAdress}>Адрес доставки</h1>
        <img
          src={cancelicon}
          onClick={() => {
            dispatch(closePopup());
          }}
        />
      </div>
      <FormProvider {...methods}>
        <form className={styles.AddForm} onSubmit={handleSubmit(onSubmit)}>
          <div className={styles.needDeliveryAddressInputs}>
            <div className={styles.AddDeteils}>
              {addreslist.map((item, index) => (
                <AdressCard
                  title={item.full_address}
                  subtitle={`
                    ${item.entrance === 0 ? '' : `подъезд ${item.entrance},`}
                    ${item.floor === 0 ? '' : `этаж ${item.floor},`}
                    ${item.intercom === '' ? '' : `домофон ${item.intercom},`}
                    ${item.elevator_type === '' ? '' : `лифт ${item.elevator_type}`}`}
                  addresRef={item.ref}
                  key={index}
                  setAddress={(ref) => {
                    setAddreslist((prev) => prev.filter((i) => i.ref !== ref));
                  }}
                  handleClick={() => {
                    setSelectedAddres(item);
                  }}
                  isSelected={item?.ref === selectAddres?.ref}
                />
              ))}
            </div>
          </div>
          {/* <div className={styles.addComment}>
            <FormInput
              label="Уточнение адреса"
              inputName="comment"
              placeholderText="Комментарии к адресу для курьера"
              isTextarea
            />
          </div> */}
          <div className={styles.buttonsRos}>
            <GreyButton
              text="Добавить новый адрес"
              width={246}
              height={56}
              onClick={() => {
                dispatch(
                  openPopup({
                    name: 'addAdress',
                    props: {
                      isSelect: true,
                    },
                  })
                );
              }}
            />
            <RedButton
              text="Сохранить"
              width={246}
              height={56}
              onClick={() => {
                dispatch(setSelectAddres(selectAddres));
                dispatch(closePopup());
              }}
            />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}

export default SelectAddresPopup;
